import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyBacklogRoute: InvariantJiraRoute = {
	name: 'legacy-backlog',
	path: '/secure/RapidBoard.jspa',
	query: ['rapidView', 'view=(.*planning.*)'],
};
